import { render, staticRenderFns } from "./VxBreadcrumb.vue?vue&type=template&id=56623f2c"
import script from "./VxBreadcrumb.vue?vue&type=script&lang=js"
export * from "./VxBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports